export default {
    LANDING: 'landing',

    // DASHBOARD
    DASHBOARD: 'dashboard',

    // SEARCH
    SEARCH: 'search',
    VIEW_SEARCH: 'viewSearch',
    TEMPLATE: 'template',
    TAG_UPDATES: 'tagUpdates',
    COMMENTS: 'comments',
    MANAGE_SOURCES: 'manageSources',
    SOURCE_LIST: 'sourceList',
    ARCHIVE: 'archive',
    SEARCH_INSIGHTS: 'searchInsights',
    UNSAVED_SEARCH_INSIGHTS: 'unsavedSearchInsights',

    // ANALYZE
    ANALYZE: 'analyze',
    WELCOME: 'welcome',
    CREATE_ANALYSIS: 'createAnalysis',
    EDIT_ANALYSIS: 'editAnalysis',
    VIEW_CHART: 'viewChart',
    SAVED_ANALYSIS: 'savedAnalysis',

    // SHARE
    SHARE: 'share',
    NEWSLETTERS: 'newsletters',
    CREATE_NEWSLETTER: 'createNewsletter',
    EDIT_NEWSLETTER: 'editNewsletter',
    CUSTOMIZE_NEWSLETTER: 'customizeNewsletter',
    CUSTOMIZE_NEW_NEWSLETTER: 'customizeNewNewsletter',
    EMAIL_USER_MANAGER: 'emailUserManager',
    EMAIL_THEMES: 'emailThemes',
    EXPORT: 'export',
    NEWSLETTER_SUBSCRIPTIONS: 'newsletterSubscriptions'
};
